
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-and-engineering",
      function () {
        return require("private-next-pages/design-and-engineering.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-and-engineering"])
      });
    }
  